import React from 'react';
import { useField } from 'formik';

interface TeamsInputProps {
    label: string;
    name: string;
    mandatory?: boolean;
    classes?: string;
}

const TeamsInput: React.FC<TeamsInputProps> = ({ label, name, mandatory = false, classes }) => {
    const [field, meta] = useField(name);

    return (
        <tr>
            <th>
                {mandatory && <span>*</span>}
                {label}:
            </th>
            <td style={{ verticalAlign: 'middle' }}>
                <input
                    {...field}
                    id={name}
                    type="text"
                    autoComplete="off"
                    className={`text ${classes}`}
                />
                <a href={`msteams:/l/chat/0/0?users=${encodeURIComponent(field.value)}`} style={{ verticalAlign: 'middle', display: 'inline-block' }}><img src="/gfx/teams.png" alt="Teams Logo" width={25} height={25} /></a>
                {meta.touched && meta.error ? (
                    <div className="error">{meta.error}</div>
                ) : null}
            </td>
        </tr>
    );
};

export default TeamsInput;